import gql from 'graphql-tag';

export default gql`
  fragment PromoPaymentFragment on PromoPayment {
    id
    description
    total {
      amount
      currency
    }
    isAutoApplied
  }
`;
